export const hostCitiesConst: string[] = [
  'Wrocław',
  'Warszawa',
  'Kraków',
  'Gdańsk',
  'Poznań',
  'Łódź',
  'Szczecin',
  'Katowice',
  'Lublin',
  'Białystok',
  'Bydgoszcz',
  'Gdynia',
  'Rzeszów',
  'Toruń',
  'Olsztyn'
];

export const visibleHostCitiesCount: number = 4;
